import { isNewBridgeView } from './utils'
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
function setupWebViewJavascriptBridge(callback) {
    //监听
    console.log(window.WebViewJavascriptBridge, 'window.WebViewJavascriptBridge')
    if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge)
    } else {
        document.addEventListener('WebViewJavascriptBridgeReady', function () {
            console.log('WebViewJavascriptBridgeReady')
            callback(WebViewJavascriptBridge)
        })
    }
    if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
    if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
    window.WVJBCallbacks = [callback]; // 创建一个 WVJBCallbacks 全局属性数组，并将 callback 插入到数组中。
    var WVJBIframe = document.createElement('iframe'); // 创建一个 iframe 元素
    WVJBIframe.style.display = 'none'; // 不显示
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'; // 设置 iframe 的 src 属性
    document.documentElement.appendChild(WVJBIframe); // 把 iframe 添加到当前文导航上。
    setTimeout(function () { document.documentElement.removeChild(WVJBIframe) }, 0)
}
let callNativeNums = 0
function callNative(data) {
    if (isNewBridgeView()) { //新版本统一用dsbridge，不在调用
        return
    }
    if (isAndroidApp) {
        console.log('android: 调用接口')
        if ((!window.WebViewJavascriptBridge) || (!window.WebViewJavascriptBridge.callHandler)) {
            console.log('android: 没有对象，继续调用接口')
            const timer = setTimeout(() => {
                callNativeNums++
                if (callNativeNums < 15) {
                    clearTimeout(timer)
                    return
                }
                callNative(data)
            }, 300)
            return;
        }
        console.log('android: 调用callHandler')
        window.WebViewJavascriptBridge.callHandler(data.fun, data.data, function (res) {
            console.log('res:', res)
            let responseData = {}
            if (res) {
                responseData = JSON.parse(res)
            }
            if (typeof data.callback === 'function') {
                data.callback(responseData)
            }
        })
    } else {
        setupWebViewJavascriptBridge(function (bridege) {
            bridege.callHandler(data.fun, data.data, function responseCallback(res) {
                if (typeof data.callback === 'function') {
                    console.log(res, 'res11')
                    data.callback(res)
                    if(data.fun === 'getData') {
                        // 存储local
                        localStorage.setItem('clientCommonMessage', JSON.stringify(res))
                    }
                }
            })
        })
    }
}

function htmlRegister(res) {
    console.log('收到安卓消息====> ', res)
    const androidResult = JSON.parse(res || '{}')
    if (androidResult.event === 'getData') {
        // 存储local
        localStorage.setItem('clientCommonMessage', JSON.stringify(androidResult.dataJson))
    }
    window.$eventBus.emitEvent('receiveAndroidMsg', [res])
}
window.AndroidHtml = {
    htmlRegister: htmlRegister
}

class mobileNativeSDK {
    constructor() {
        this.registerFunctionForNative()
    }
    /**
     * 获取拍批照片URL
    */
    getData(callback) {
        callNative({ fun: 'getData', callback })
    }
    /**
     * 跳转登录
    */
    goLogin(data = {}) {
        callNative({ fun: 'login', data })
    }
    /**
     * 调用原生播放器播放视频
     * data: {
     *  resource_vod_src: string m3u8视频地址
     *  resource_src: string mp4视频地址
     * }
    */
    playVideo(data, callback) {
        callNative({ fun: 'playVideo', data, callback })
    }
    /**
     * 显示激活弹框
     * data: {
     *  message_info: string 弹框文本
     * }
    */
    showActiveAlert(data, callback) {
        callNative({ fun: 'showActiveAlert', data, callback })
    }

    /**
     * 再拍一次
    */
    reTakePhoto() {
        callNative({ fun: 'reTakePhoto' })
    }

    /**
     * 设置微信分享信息
    */
    wxShare(data) {
        callNative({ fun: 'wxShare', data })
    }

    /**
    * 调用原生弹框
    * data: {
    *  message: string 弹框文本
    *  buttonTxt: string 按钮文本
    * }
   */
    nativeConfirm(data) {
        callNative({ fun: 'nativeConfirm', data })
    }
    /**
    * 调用原生Toast
    * data: {
    *  message: string 提示文案
    *  timer: number 显示时长 单位:秒
    * }
   */
    nativeToast(data) {
        callNative({ fun: 'nativeToast', data })
    }
    /**
    * 注销账号弹窗
    * data: {
    *  reason_id: string 注销理由id
    * }
   */
    deleteAccount(data) {
        callNative({ fun: 'deleteAccount', data })
    }

    /**
    * 获取设备信息
   */
    getDeviceInfo(callback) {
        callNative({ fun: 'deviceInfo', callback })
    }

    // 调用端内跳转
    doJump(data) {
        callNative({ fun: 'doJump', data })
    }

    // 注册js方法供端上调用
    registerFunctionForNative() {
        if (isNewBridgeView() || !ua.includes('ibook')) {
            return
        }
        setupWebViewJavascriptBridge(function (bridege) {
            console.log('registerFunctionForNative')
            bridege.registerHandler('changeQuestion', function (res) {
                window.$eventBus.emitEvent('receiveIosMsg', [res])
            })
            bridege.registerHandler('changeVideo', function (res) {
                console.log(res, 'changeVideo')
                window.$eventBus.emitEvent('receiveChangeVideoIosMsg', [res])
            })
            bridege.registerHandler('refreshQuestionStatus', function (res) {
                console.log(res, 'refreshQuestionStatus')
                window.$eventBus.emitEvent('refreshQuestionStatus', [])
            })
            bridege.registerHandler('deleteAccountResult', function (res) {
                console.log(res, 'deleteAccountResult')
                window.$eventBus.emitEvent('deleteAccountResult', [res])
            })
            bridege.registerHandler("updateToken", (data = {}) => {
                const { token = '' } = data
                console.log('收到新的token', token)
                if (token) {
                  window.localStorage.setItem('tal_token', token);
                  const clientCommonMessage = JSON.parse(localStorage.getItem('clientCommonMessage') || '{}')
                  localStorage.setItem('clientCommonMessage', JSON.stringify({...clientCommonMessage, token}))
                }
                return {
                  message: `更新token成功-1`,
                  token
                }
            });
        })
    }

}
var mobileNativeSDKObj = new mobileNativeSDK()
export default mobileNativeSDKObj